import { useDispatch, useSelector } from "react-redux";
import {
  setStats,
  clearStats,
} from "../../store/slices/dashboard/inventoryDashboardSlice";
import { AppDispatch, RootState } from "../../store/store";
import InventoryDashboardService from "../../services/dashboard/InventoryDashboardService";
import useApiErrorHandler from "../useApiErrorHandler";
// import useLoading from "../useLoading";

export const useInventoryDashboard = () => {
  const dispatch: AppDispatch = useDispatch();
  const { handle } = useApiErrorHandler();
  // const { showLoadingIndicator, hideLoadingIndicator } = useLoading();

  // ✅ Estados desde Redux
  const { stats } = useSelector(
    (state: RootState) => state.inventoryDashboard
  );

  /**
   * 📊 Cargar estadísticas del dashboard de inventario
   */
  const fetchStats = async () => {
    try {
      // showLoadingIndicator();

      const response = await InventoryDashboardService.getStats();
      if (response?.statusCode === 200) {
        const { data } = response;
        dispatch(setStats(data));
        // 🚫 Ya no abrimos ningún modal aquí
      }
    } catch (error: any) {
      handle(error);
    } finally {
      // hideLoadingIndicator();
    }
  };

  /**
   * 🔄 Limpiar estadísticas (si necesitas resetear en algún momento)
   */
  const resetStats = () => {
    dispatch(clearStats());
  };

  return {
    stats,
    fetchStats,
    resetStats,
  };
};

export default useInventoryDashboard;
